import * as PIXI from 'pixi.js';
import GameConfig from './GameConfig';

import Point = PIXI.Point;
import Sprite = PIXI.Sprite;
import Spritesheet = PIXI.Spritesheet;

class GameUtils {
    public randColor(): number {
        // tslint:disable-next-line:no-bitwise
        return parseInt('0x' + ((Math.random() * 0xffffff) << 0).toString(16), 16);
    }

    public makeSprite(
        name: string,
        x: number,
        y: number,
        scale: number = 1,
        color: number = 0xffffff
    ): Sprite {
        const texture = this.spriteTexture(name);
        const sprite = new Sprite(texture);
        sprite.pivot.set(sprite.width / 2, sprite.height / 2);
        sprite.position = new Point(x, y);
        sprite.scale = new Point(scale, scale);
        sprite.tint = color;
        return sprite;
    }

    public spriteTexture(name: string): PIXI.Texture {
        const sheet: Spritesheet = (PIXI.loader.resources[
            GameConfig.spritesheetUrl
        ] as unknown) as Spritesheet;
        return sheet.textures[`${name}.png`];
    }
}

export default Object.freeze(new GameUtils());



// WEBPACK FOOTER //
// ./src/game/GameUtils.ts